import * as React from "react";

import "./templates.scss";

import {faSpinner}          from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon}    from "@fortawesome/react-fontawesome";
import {Link}               from "react-router-dom";
import {cx}                 from "emotion";

import {cbc}                                    from "@Common/react/callback-chain";
import {cs}                                     from "@Common/react/chain-services";
import {ComponentLink, makeChain, valueHelper}  from "@Common/react/cst2";
import {keyed}                                  from "@Common/react/keyed";
import {Load2}                                  from "@Common/react/load2";
import {isEdge, isIe}                           from "@Common/ui-components/debug/is-ie-edge-or-firefox";
import {PaywallModal}                           from "@Common/ui-components/paywall-modal/paywall-modal"

import {consumeContext} from "@Xpresso/loaders/consume-context";

import {Tooltip}                from "../../../../common/tool-tip";
import {SlideCarousel}          from "../slide-carousel/slide-carousel";
import {templateDownloadModal}  from "../template-download-modal/template-download-modal";
import {TemplateSvgThumbnail}   from "../template-svg-thumbnail/template-svg-thumbnail";

export const rTemplates = (templates, {subId, catId, mode = "medium", userCreated = false, onNavigate = null}) => (
    <div className={cx("templates templates-43f", mode, {"ie": isIe(), "edge": isEdge()})}>
        {templates.map((template: any) => (
            rTemplateTile({template, subId, catId, userCreated, onNavigate})
        ))}
    </div>
);

const rTemplateTile = ({template, subId, catId, userCreated, onNavigate}) => cs(
    keyed(template.id),
    consumeContext("catSubStyle"),
    consumeContext("company"),
    ["templateDownloadModal", (_, next) => templateDownloadModal({
        allowSocialShare: template.allowSocialShare,
        templateDownloadUrl: template.downloadImageUrl,
        templateId: template.id,
        templateName: template.name.trim(),
        next
    })],
    ["paywallModal", (_, next) => PaywallModal({next})],
    ({catSubStyle, company, paywallModal, templateDownloadModal}) => (
        <Link
            to={!userCreated ?
                `/product-options/${template.id}` :
                `/product-options/${template.sourceTemplateId}/${template.id}`
            }
            className="template" xd-qa-type="template"
            onClick={(e) => {
                onNavigate && onNavigate(
                    (
                        !userCreated
                        ? `/product-options/${template.id}`
                        : `/product-options/${template.sourceTemplateId}/${template.id}`
                    ),
                    template.name.trim(),
                    template
                );
                if ( template.noProofPopupModal && catSubStyle?.value?.[catId(template.styleId)]?.categoryType == "subscriber" && template.allowSubscription !== undefined && !template.allowSubscription ){
                    paywallModal.show();
                    e.preventDefault();
                }
                else if( template.noProofPopupModal ) {
                    templateDownloadModal.show();
                    e.preventDefault();
                }
            }}
        >
            <Tooltip/>
            {SlideCarousel({slides: getCarouselImages({
                template,
                name:template.name.trim(),
            })})}
            <div className="content">
                <div
                    className="name"
                    data-tip={template.name.trim()}
                >
                    {template.name.trim()}
                </div>
                <div className="hr"/>

                <div
                    className="size1"
                    data-tip={template.product.name.trim()}
                >
                    {template.product.name.trim()}
                </div>
                <div className={cx("size2", {
                    padding: company?.prefs.smartTemplateIcon && template.proofEngineType === 0
                })}>
                    {cbc(template.product, [
                        (_, next) => (
                            <table>
                                <tbody>
                                {next(_)}
                                </tbody>
                            </table>
                        ),
                        (p) => <>
                            {p.finishedWidth != 0 && p.finishedHeight != 0 && (
                                <tr data-tip={`Finished Size: ${p.finishedWidth}" x ${p.finishedHeight}"`}>
                                    <td className='right'>Finished Size:</td>
                                    <td>{p.finishedWidth}{`"` }{" x "}{p.finishedHeight}{`"`}</td>
                                </tr>
                            )}

                            {(
                                (p.finishedWidth != 0 && p.finishedHeight != 0) &&
                                (p.flatWidth != p.finishedWidth || p.flatHeight != p.finishedHeight )
                            ) && (
                                <tr data-tip={`Flat Size: ${p.finishedWidth}" x ${p.finishedHeight}"`}>
                                    <td className='right'>Flat Size:</td>
                                    <td>{p.flatWidth}{`"` }{" x "}{p.flatHeight}{`"`}</td>
                                </tr>
                            )}
                        </>,
                    ])}
                </div>
                {company?.prefs.smartTemplateIcon && template.proofEngineType === 0 && (
                    <div className="icon" xd-qa-type="icon" xd-qa-name="Smart Template Icon">
                        <img alt="Smart Template" src="/next_images/icons/SmartTemplateIcon.svg"/>
                    </div>
                )}
            </div>
            {( catSubStyle?.value?.[catId(template.styleId)]?.categoryType == "subscriber" ) && <div className="subscription-box"
                style={{
                    backgroundImage: `url("/next_images/XDPlusTileBanner.svg")`,
                }}
            />}
            {template.internalUser === true && (
                <div className="template-id-box">
                    {userCreated && `${template.sourceTemplateId}-`}{template.id}
                </div>
            )}
        </Link>
    )
);

const ImageBox = ({alt, url}:{alt?: string, url: string}) => (
    makeChain<JSX.Element>()
    .then(...consumeContext("svgThumbnailsCache"))
    .then("isSvg", valueHelper(() => url.endsWith(".svg")))
    .then("svgCodeLoad", ({isSvg, svgThumbnailsCache}, next: ComponentLink<typeof Load2<string>>) => (
        Load2({next, _key: url, fetch: async () => isSvg ? svgThumbnailsCache.loadUrl(url) : ""})
    ))
    .then(({isSvg, svgCodeLoad: {loading, value: svgCode}}) => (
        isSvg ? (
            <div className="svg box" title={alt}>{
                loading
                ? <FontAwesomeIcon icon={faSpinner} spinPulse/>
                : <TemplateSvgThumbnail svgCode={svgCode}/>
            }</div>
        ) : (
            <div className="box"><img className="image" src={url} alt={alt}/></div>
        )
    ))
    .run()
);

const getCarouselImages = ({template, name}) => {
    let arr = [];

    arr.push(<>
        <ImageBox url={template.images[4]?.url ?? "assets/NoImageAvailable.png"} alt={name}/>
        {(
            template.product.internalDescription != "Postcard"
            && template.templatePage === "both"
            && template.images[5]
            && (
                <ImageBox url={template.images[5].url} alt={name}/>
            )
        )}
    </>);

    const tmp = template.thumbnails ? template.thumbnails.map(url => (<>
        <ImageBox url={url} alt={name}/>
    </>)) : [];
    return [...arr, ...tmp];
}

